import { format } from "date-fns";
import React, {useEffect, useState} from "react";
import _, { wrap } from "lodash";
import { connect } from "react-redux";
import { useFormik } from "formik";
import StateMap from "store/stateMap";
import { popinfo } from "component/Fancybox/Fancybox";
import api from "api";
import { useFilePicker } from "use-file-picker";
import Slugify from "slugify";
import update from "immutability-helper";
import {ReactComponent as SVGClose} from '../../assets/close.svg';
import "./style.scss";
import IsValidEmail from "lib/IsValidEmail";

const EditPageForm = (props) => {

    const [page, setPage]               = useState(props.page);

    const [pageAdmin, setPageAdmin]     = useState([]);

    const [slugLoading, setSlugLoading] = useState(false);

    const [formLoading, setFormLoading] = useState(true);

    const [openFileSelector, { filesContent, plainFiles, clear }] = useFilePicker({
        readAs: 'DataURL',
        accept: ['image/png', 'image/jpg', 'image/jpeg'],
        multiple: false,
        limitFilesConfig: { max: 1 },
        maxFileSize: 2,
    });

    const correctingEligibleSlug = (Slug) => {
        setSlugLoading(true);

        var slug = Slugify(Slug, {
            lower : true
            ,strict : true
        });

        api('/IsPageSlugEligible', 'get', {
            'Slug'              : slug
            ,'PageID'           : formik.values.PageID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                
                setSlugLoading(false);
                
                formik.setFieldValue('PageSlug', response.slug);
            })
            .catch((error) => {
                setSlugLoading(false);

                formik.setFieldValue('PageSlug', '');
            });
        }

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {

            if(value === null)
            {
                value = '';
            }

            formik.setFieldValue(attribute, value);
        });
    }

    const formik = useFormik({
        initialValues: {
            PageID          : 0
            ,PageName       : ''
            ,PageDesc       : ''
            ,PageSlug       : ''
            ,PagePhoto      : ''
        }
        ,onSubmit: values => {

            let anyEmailInvalid = _.filter(pageAdmin, {valid : false});

            if(slugLoading)
            {
                return;
            }

            if(anyEmailInvalid.length)
            {
                return popinfo('error', 'Invalid email address' ,'there are some emails that don\'t use the proper format', {}, );
            }

            var SavingLoader = popinfo('loader', 'Saving Page', 'Please wait');

            api('/Pages', 'post', _.assignIn({
                pageAdmin : _.map(pageAdmin, 'email')
            }, values, filesContent.length ? {
                uploadedPicture : {
                    data : filesContent[0].content
                    ,name : filesContent[0].name
                }
            } : {}), 'Bearer ' + props.auth.token)
                .then(function(response){
                    
                    SavingLoader.close();
                    
                    settingFormValues(response.page);

                    props.onSave(response.page);
                        
                })
                .catch((error) => {
                    popinfo('error', 'Saving Page', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {


        settingFormValues(props.page);

        if(props.page && props.page.PageID)
        {
            api('/PagesAdmin', 'get', {page_id : props.page.PageID})
                .then(response => {
                    setPageAdmin(_.map(response.admin, (admin) => {
                        return {
                            email   : admin
                            ,valid  : true
                        }
                    }))
                })
        }
        else
        {
            setFormLoading(false);
        }

    }, [props.page]);

    return (
        <form className="generic-form"  onSubmit={formik.handleSubmit}>
            <div className="page-image">
                <span className="image-box square w-100 mx-auto rounded border-solid" style={{width : '100px'}} onClick={(e) => {
                    e.preventDefault();

                    openFileSelector();

                }}>
                    {
                        formik.values.PagePhoto.length > 0 && filesContent.length < 1 &&
                            <img src={formik.values.PagePhoto}></img>
                    }
                    {
                        filesContent.length > 0 && 
                            <img alt={filesContent[0].name} src={filesContent[0].content}></img>
                    }

                </span>
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Page Name</label>
                <div className="description">Type the page name</div>
                {
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                            formik.handleBlur(e);

                            if(formik.values.PageSlug == '')
                            {
                                correctingEligibleSlug(e.currentTarget.value);
                            }
                        }}
                        value={formik.values.PageName}
                        name="PageName"
                    />
                }
            </div>
            {
                page && 
                <div className="form-group">
                    <label htmlFor="" className="label">Creator</label>
                    <input type="text" className="form-control text" disabled="disabled" value={page.Creator_UserDisplayName}/>
                </div>
            }
            <div className="form-group">
                <label htmlFor="" className="label">Page URL Identifier</label>
                <div className="description leading-text">
                    Type your preferred page identifier, this will help you advertise your page easily <br />
                    <span className="bold">
                        {props.config.base_url}/page/{formik.values.PageSlug || '...'}
                    </span>
                </div>
                {
                    slugLoading ? <span className="skeleton"></span> : 
                    <input type="text" className="form-control text" 
                        onBlur={(e) => {
                            formik.handleBlur(e);
                            if(formik.values.Slug != e.currentTarget.value)
                            {
                                correctingEligibleSlug(e.currentTarget.value || formik.values.Title);
                            }
                        }}
                        defaultValue={formik.values.PageSlug}
                        name="PageSlug"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Description</label>
                <div className="description">Give brief description about your page</div>
                {
                    <textarea
                        className="form-control textarea" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.PageDesc}
                        name="PageDesc"
                    ></textarea>
                }
            </div>
            <div className="form-group">
            <label htmlFor="" className="label">Page Administrator</label>
                {
                    pageAdmin.map((admin, index) => (
                        <div className={`page-admin-input-wrap ${admin.valid ? 'valid' : 'invalid'}`} key={index}>
                            <input 
                               type="text" 
                               className={`form-control text` }
                               defaultValue={admin.email}
                               onKeyDown={ e => {
                                if(e.keyCode === 13)
                                {
                                    e.preventDefault();
                                }
                               }}
                               onChange={ _.debounce( e => {
                                   
                                   setPageAdmin(update(pageAdmin, {
                                       [index] : {$set : {
                                            email : e.target.value
                                            ,valid : true
                                       }}
                                   }));
   
                               }, 200 )}
                               onBlur={ e => {

                                    if(!IsValidEmail(e.target.value) && e.target.value.length > 3)
                                    {
                                        setPageAdmin(update(pageAdmin, {
                                            [index] : { valid : {
                                                 $set : false
                                            }}
                                        }));

                                        return popinfo('error', 'Invalid email address' ,'Please input valid email address', {}, );
                                    }
                               }}
                            />
                            {
                                admin.email !== props.auth.user.UserEmail &&
                                <span className="remove-admin-button" onClick={e => {
                                    e.preventDefault();

                                    if(pageAdmin.length === 1)
                                    {
                                        setPageAdmin(update(pageAdmin, {
                                            $set : []
                                        }));
                                    }
                                    else
                                    {
                                        setPageAdmin(update(pageAdmin, {
                                            $splice : [[index , 1]]
                                        }));
                                    }
                                }}>
                                    <SVGClose/>
                                </span>
                            }
                            
                        </div>
                        
                    ))
                }
                {
                    pageAdmin.length == 0 && 
                    <div className="text-xs leading-text font-light mb-sm">No additional administrator added, only Page creator can manage this page</div>
                }
                <a href="" className="btn btn-mini btn-primary btn-reverse" onClick={(e) => {
                    e.preventDefault();

                    setPageAdmin(update(pageAdmin, {
                        $push : [{
                            email : ''
                            ,valid : true
                        }]
                    }));
                }}>Add Administrator</a>
            </div>
            <hr />
            {
                !slugLoading && 
                <div className="text-right">
                    <button type="submit" className='btn btn-orange'>Save</button>
                </div>
            }
        </form>
    )
}

export default connect(StateMap)(EditPageForm);